<template>
  <div class="row m-0">
    <div class="col-12 col-md-3 p-3 d-flex">
      <form class="align-self-center flex-fill">
        <div class="form-group" data-bs-toggle="tooltip" data-bs-delay="500" title="Consistency Score comparison among population">
          <label>Compared to population of</label>
          <select class="form-control" v-model="chartPopulation" :disabled="isLoading">
            <option value="all">All Interviewees</option>
            <option value="organization">{{ organizationDisplayName }}</option>
          </select>
          <small class="form-text text-muted">Sample size: {{ sampleSize }}</small>
        </div>
      </form>
    </div>
    <div v-if="showChart" class="col-12 col-md-9 p-3">
      <BarChart v-if="chartData" :data="chartData" :options="chartOptions" style="height: 300px;" />
    </div>
    <div v-if="!showChart" class="col-12 col-md-8 p-3 d-flex justify-content-center align-items-center" style="height: 332px;">
      <div>
        <p class="text-center text-muted">
          No data available
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/charts/BarChart.vue";

export default {
  components: {
    BarChart,
  },
  props: {
    isLoading: Boolean,
    organizationId: String,
    reportId: String,
    report: Object,
  },
  data() {
    return {
      chartPopulation: "all",
      chartSampleSize: null,
      chartData: null,
      chartOptions: null,
      showChart: false,
    };
  },
  computed: {
    organizationDisplayName() {
      return this.report ? this.report.organizationDisplayName : "My Organization";
    },
    sampleSize() {
      try {
        return this.chartSampleSize.toLocaleString();
      } catch {
        return this.chartSampleSize;
      }
    },
  },
  watch: {
    chartPopulation() {
      this.loadChart();
    },
    report() {
      this.loadChart();
    },
  },
  mounted() {
    this.loadChart();
  },
  methods: {
    loadChart() {
      this.showChart = false;
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/reports/${this.reportId}/charts/consistency?populationCode=${this.chartPopulation}`)
        .then(res => {
          const chartOptions = {
            legend: false,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  type: "logarithmic",
                  display: true,
                  gridLines: {
                    display: false,
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Frequency",
                  },
                  ticks: {
                    beginAtZero: true,
                    display: false,
                  },
                },
              ],
              xAxes: [
                {
                  offset: true,
                  gridLines: {
                    offsetGridLines: false,
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Consistency Score (Population)",
                  },
                  ticks: {
                    beginAtZero: true,
                    precision: 0,
                    step: 5,
                    max: 100,
                    maxTicksLimit: 20,
                  },
                },
              ],
            },
            plugins: {
              datalabels: false,
            },
            annotation: {
              annotations: [
                {
                  type: "line",
                  scaleID: "x-axis-0",
                  mode: "vertical",
                  borderColor: "#cb4c55",
                  value: res.data.score,
                  label: {
                    content: `${res.data.score}%`,
                    backgroundColor: "#cb4c55",
                    fontColor: "white",
                    position: "top",
                    enabled: true,
                  },
                },
              ],
            },
            tooltips: {
              callbacks: {
                title: function() {},
                label: function(tooltipItem, data) {
                  var label = data.labels[tooltipItem.index] || "";
                  if (label) {
                    label += "%: ";
                  }
                  label += data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                  return label;
                },
              },
            },
          };

          const chartData = {
            labels: [],
            datasets: [
              {
                label: "Consistency Score (Population)",
                data: [],
                backgroundColor: [],
              },
            ],
          };

          res.data.dataPoints.forEach(point => {
            chartData.labels.push(point.label);
            chartData.datasets[0].data.push(point.y);
            chartData.datasets[0].backgroundColor.push("#182c59");
            this.showChart = true;
          });

          this.chartSampleSize = res.data.sampleSize;
          this.chartData = chartData;
          this.chartOptions = chartOptions;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

@media print {
  .form-control {
    -webkit-appearance: none;
    border: none;
    font-weight: bold;
    padding-left: 0;
  }
}
</style>
